import React from "react";
import NewsCarousel from "./NewsCarousel.js";
import { mockNewsArticles } from "../../data/mockNews.js";

interface NewsSectionProps {
  className?: string;
}

const NewsSection: React.FC<NewsSectionProps> = ({ className }) => {
  return (
    <section className={`py-8 ${className || ""}`}>
      <div className="px-4 sm:px-8 lg:px-24">
        <div className="content-container">
          <h2 className="mb-6 text-2xl font-semibold text-white sm:text-3xl">
            Consultez nos nouvelles météorologiques et scientifiques
          </h2>

          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-white">Actualités</h3>
            <a
              href="#"
              className="flex items-center gap-2 rounded border border-white px-3 py-1 text-sm text-white hover:bg-white hover:text-nearblack-500"
            >
              <span>Plus de nouvelles</span>
              <i className="fas fa-arrow-right"></i>
            </a>
          </div>

          <NewsCarousel articles={mockNewsArticles} />
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
